function LinkoutSVG() {
    return (
        <>
            <svg
                width={17}
                height={16}
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.50001 3.33333V2H14.5V8H13.1667V4.27624L7.63813 9.80479L6.69532 8.86198L12.224 3.33333H8.50001ZM6.50001 5.33333H3.16667V13.3333H11.1667V10H9.83334V12H4.50001V6.66667H6.50001V5.33333Z"
                    fill="white"
                />
            </svg>
        </>
    )
}

export default LinkoutSVG;
